import { intersect, struct } from 'io-ts/Decoder';

import { Request as SearchRequest } from '../../../../report/usage-reports';
import { Request as PaginationRequest } from '../../../generic/pagination/definite/Request';

export const Request = intersect(SearchRequest)(
	struct({
		pagination: PaginationRequest,
	})
);
